<template>
  <div v-if="!logged" style="width: 100vw; height: 100vh">
    <div class="login">
      <div class="login-dialog">
        <div class="login-dialog-left"><img src="../../assets/images/login_bg.png" class="img_max" /></div>
        <div class="login-dialog-right">
          <p>智招科技用户登录</p>
          <div class="form-box">
            <p style="font-size: 14px;margin-bottom: 20px;color: #F56C6C;">{{ accountErrorMessage }}</p>
            <el-input
              v-model="account"
              placeholder="账号"
              @input="accountErrorMessage = ''"
              style="margin-bottom:20px"
              prefix-icon="el-icon-user-solid"
            >
            </el-input>
            <el-input v-model="password" placeholder="密码" prefix-icon="el-icon-s-goods" show-password> </el-input>
          </div>
          <div><el-button type="primary" style="width: 100%;" round @click="login">登录</el-button></div>
          <div class="text-btn-box">
            <span class="text-btn" @click="wechat_login">微信登录</span>
            <span class="text-btn" @click="sign">立即注册</span>
          </div>
          <div class="temp-text-btn-box"><span class="text-btn" @click="applyForTempLogin">申请临时登录</span></div>
        </div>
      </div>
    </div>
    <div>
      <span style="position:absolute;bottom:0;">
        © 2020 阿尔法人力资源.<a href="http://www.beian.miit.gov.cn" target="_blank">京ICP备17066583号-3</a>
      </span>
    </div>

    <!-- component -->
    <ApplyForTempLoginDialog ref="ApplyForTempLoginDialog"></ApplyForTempLoginDialog>
  </div>
</template>

<script>
import cookies from 'js-cookie'
import { getQueryString } from '../../project/src/constant/utils'
import ApplyForTempLoginDialog from './ApplyForTempLoginDialog'

export default {
  name: 'Login',
  components: { ApplyForTempLoginDialog },
  data() {
    return {
      account: '',
      password: '',
      logged: false,
      wechat_url: '',
      invitationCode: '',
      accountErrorMessage: '',
    }
  },
  computed: {
    not_prod() {
      return app.name == 'test' || app.name == 'dev'
    },
  },
  mounted() {
    const jwt = getQueryString('jwt')
    if (jwt) {
      cookies.set('feathers-jwt', jwt, { expires: 1 })
      location.reload()
    } else {
      cookies.set('redirect_url', location.href)
    }
    // 有一个一分钟的计时，如果没有登录就会reload，导致页面无法填写，因此需要清除计时，登陆成功后再恢复计时
    clearInterval(app.loginInterval)
  },
  methods: {
    sign() {
      // TODO:部署之后更换链接
      // window.open('http://localhost:9528/#/sign', '_blank')
      window.open('http://39.106.4.59:3400/#/sign', '_blank')
    },
    applyForTempLogin() {
      this.$refs.ApplyForTempLoginDialog.open()
    },
    async login() {
      let failcount = localStorage.getItem('failcount') || 0
      let failtime = localStorage.getItem('failtime')
      if (failtime && (Date.now() - failtime > 7200000)) {
        // 大于2小时清空
        localStorage.setItem('failcount', 0)
        failcount = 0
        this.accountErrorMessage = ''
      } else {
        if (failcount && failcount >= 5) {
          this.accountErrorMessage = '登录失败次数太多，已被锁定，请2小时后再登'
          return false
        }
      }
      return app
        .authenticate({
          account: this.account,
          password: this.password,
          strategy: 'local',
        })
        .then(({ accessToken }) => {
          this.logged = true
          // 登录成功恢复计时
          app.setLoginInterval()
          localStorage.setItem('failcount', 0)
          return app.emit('login', { accessToken })
        })
        .catch(e => {
          this.$msgbox(`用户名或密码错误！还可以尝试${4 - failcount}次`)
          localStorage.setItem('failcount', parseInt(failcount) + 1)
          localStorage.setItem('failtime', Date.now())
          console.log('error', e)
          return false
        })
    },
    async invitationCodeLogin() {
      try {
        const {
          data: { user, accessToken },
        } = await this.$axios.get(`${window.host}/invitationCode/${this.invitationCode && this.invitationCode.trim()}`)
        const redirect = cookies.get('redirect_url')
        cookies.remove('redirect_url')
        cookies.set('feathers-jwt', accessToken, { expires: 1 })
        if (redirect) location.href = redirect
        return location.reload()
      } catch (e) {
        this.$msgbox('登录失败！')
        console.log('error', e)
        return false
      }
    },
    wechat_login() {
      let uri = 'https://www.alphaconsulting.top/wxcallback'
      if (app.name === 'syn') {
        uri = 'http://www.alphaconsulting.top/wxcallback-mi'
      }
      if (window.location.host.indexOf('aconsulting.top') !== -1) {
        uri = 'http://www.alphaconsulting.top/wxcallback-a'
      }
      return (location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wx0a3a78885aaf0f6f&redirect_uri=${encodeURI(
        uri,
      )}&response_type=code&scope=snsapi_login#wechat_redirect`)
    },
    wechat_bind() {
      let ref
      if (((ref = this.wechat_url) != null ? ref.indexOf(window.host) : void 0) === 0) {
        return (location.href = this.wechat_url)
      } else {
        return this.$msgbox('请输入合法的绑定链接．')
      }
    },
  },
}
</script>
<style>
.login {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-dialog {
  width: 80%;
  padding: 70px 120px;
  background: rgba(255, 255, 255, 1);
  border-radius: 30px;
  display: flex;
  box-shadow: 0 0 5px 0 #d0d0d0;
  align-items: center;
  justify-content: space-between;
}
.login-dialog-left {
  width: 45%;
}
.login-dialog-right {
  width: 45%;
  height: 370px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.login-dialog-right p {
  font-size: 44px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.text-btn-box {
  display: flex;
  justify-content: space-between;
}
.text-btn {
  font-size: 18px;
  cursor: pointer;
}
.login .login-dialog-right .el-input input,
.login .login-dialog-right .el-input input:hover,
.login .login-dialog-right .el-input input:focus {
  padding-left: 30px;
}

.login .el-input input,
.login .el-input input:hover,
.login .el-input input:focus {
  border: 1px solid #dcdfe6;
  padding-left: 5px;
}
.login > .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  color: #409eff;
}
.login > .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #909399;
}
</style>
<style scoped>
.temp-text-btn-box {
  display: flex;
  justify-content: flex-end;
  color: #afafaf;
}
</style>
